import { __ } from '@wordpress/i18n'
import SbUtils from '../../Utils/SbUtils'
import Button from '../Common/Button';
import ModalContainer from './ModalContainer';

const ConfirmDialog = ( props ) => {

    /**
     * Render structured content sections
     * content: { intro, items, moreCount, warning, outro }
     */
    const renderStructuredContent = ( content ) => {
        return (
            <div className='sb-confirm-modal-content'>
                { content.intro &&
                    <p className='sb-confirm-modal-intro'>{ content.intro }</p>
                }
                { content.items && content.items.length > 0 &&
                    <ul className='sb-confirm-modal-list'>
                        { content.items.map( ( item, index ) => (
                            <li key={ index }>{ item }</li>
                        ))}
                        { content.moreCount > 0 &&
                            <li className='sb-confirm-modal-more'>
                                + { content.moreCount } { __( 'more', 'sb-customizer' ) }
                            </li>
                        }
                    </ul>
                }
                { content.warning &&
                    <p className='sb-confirm-modal-warning'>{ content.warning }</p>
                }
                { content.outro &&
                    <p className='sb-confirm-modal-outro'>{ content.outro }</p>
                }
            </div>
        );
    };

    return (
        props?.active &&
        <ModalContainer
            size='small'
            closebutton={true}
            onClose={ () => {
                props?.onClose();
            } }
        >
            <div className='sb-confirm-modal sb-fs'>
                {
                    props?.heading &&
                    <strong className='sb-confirm-modal-heading sb-dark-text sb-fs'>{ props?.heading }</strong>
                }
                {
                    props?.content &&
                    renderStructuredContent( props.content )
                }
                {
                    !props?.content && props?.description &&
                    <span className='sb-confirm-modal-description sb-text sb-dark2-text sb-fs'>{ props?.description }</span>
                }
                <div className='sb-confirm-modal-btns sb-fs'>
                    {
                        (props?.cancel !== false || props?.cancel === undefined) &&
                        <Button
                            text={ props?.cancel?.text ? props?.cancel?.text : __( 'Cancel', 'sb-customizer' ) }
                            size={ props?.cancel?.size ? props?.cancel?.size : 'medium' }
                            type={ props?.cancel?.type ? props?.cancel?.type : 'secondary' }
                            icon={ props?.cancel?.icon }
                            iconPosition={ props?.cancel?.icon ? 'left' : undefined }
                            onClick={ () => {
                                props?.onClose()
                                props?.cancel?.onCancel?.()
                            }}
                        />
                    }
                    {
                        props?.confirm &&
                        <Button
                            text={ props?.confirm?.text ? props?.confirm?.text : __( 'Confirm', 'sb-customizer' ) }
                            size={ props?.confirm?.size ? props?.confirm?.size : 'medium' }
                            type={ props?.confirm?.type ? props?.confirm?.type : 'destructive' }
                            icon={ props?.confirm?.icon }
                            iconPosition={ props?.confirm?.icon ? 'left' : undefined }
                            onClick={ () => {
                                props?.confirm?.onConfirm?.()
                                props?.onClose()
                            }}
                        />
                    }
                </div>
            </div>
        </ModalContainer>
    )
}

export default ConfirmDialog;